import { getTodayDateInHotelTimezone as o, isDateBefore as u, areDatesEqual as i } from "@amenitiz/design-system";
const n = (e, t, s) => {
  if (t) {
    const r = s;
    return r.setDate(r.getDate() + t), u(e, r);
  }
  return !1;
}, f = (e, t, s) => !!((t.getHours() > e.getHours() || t.getHours() === e.getHours() && t.getMinutes() >= e.getMinutes()) && i(t, s)), g = (e, t, s) => {
  const r = o();
  return n(e, t, r) || f(s, r, e);
};
export {
  g as isBelowMinimumDays
};
